import BackButton from 'components/common/BackButton'
import * as Common from 'components/common/Common'
import { Pagination } from 'components/common/Pagination'
import * as Typography from 'components/common/Typography'
import FormSearchRoom from 'components/forms/FormSearchRoom'
import ModalGallery from 'components/modals/ModalGallery'
import { RoomRow } from 'components/views/FindRoom/RoomRow'
import { SortBy } from 'components/views/FindRoom/SortBy'
import { ROUTE_MAKE_RESERVATION } from 'constants/routes'
import { useAppSelector } from 'hooks/useRedux'
import { useRooms } from 'logic/useRooms'
import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { selectFitCustomResolution } from 'redux/slices/app'
import { IRoom, LoaderWrapper } from 'shared-ui'
import { useTheme } from 'styled-components'
import {
  FullBorderSeparator,
  PaginationContainer,
} from 'views/desktopMobile/makeReservation/ViewMakeReservationRoomsFound.styled'

const ViewMakeReservationRoomsFound = () => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const language: string = i18n.language
  const isMobile = useAppSelector(state =>
    selectFitCustomResolution(state, 1266)
  )
  const arePaddingsShrunk = useAppSelector(state =>
    selectFitCustomResolution(state, 526)
  )
  const navigate = useNavigate()

  const [currentPageNumber, setCurrentPageNumber] = useState(1)

  const [isGalleryOpen, setIsGalleryOpen] = useState(false)
  const { handleSort, rooms, sortOrder, isLoading, pagination, searchData } =
    useRooms({
      language,
      page: currentPageNumber,
      perPage: 20,
    })

  return (
    <Common.Div
      flex="column"
      px={arePaddingsShrunk ? 3 : 12}
      py={isMobile ? 6 : 11.75}
    >
      <Common.Div
        flex={isMobile ? 'column' : 'row'}
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Typography.H2
          mb={4}
          secondary
        >
          {t('roomsFound.header')}
        </Typography.H2>
        <Common.Div
          flex="column"
          alignItems="flex-end"
        >
          <FormSearchRoom withCheckbox />
        </Common.Div>
      </Common.Div>
      <SortBy
        handleSort={handleSort}
        sortOrder={sortOrder}
      />
      <Common.BarBorder
        mb={2}
        mt={2}
      />
      <LoaderWrapper
        isLoading={isLoading}
        primaryColor={theme.colors.primary}
        secondaryColor={theme.colors.secondary}
      >
        {rooms.map((r: IRoom, index: number) => (
          <Fragment key={r.uuid}>
            <RoomRow
              setIsGalleryOpen={setIsGalleryOpen}
              data={r}
              searchData={searchData}
            />
            {index !== rooms.length - 1 && <FullBorderSeparator mb={1} />}
          </Fragment>
        ))}
        <PaginationContainer>
          <FullBorderSeparator />
          <Common.Div
            alignItems="center"
            flex="row"
            // h="48px"
            justifyContent="space-between"
            px={6}
            py={1}
            w="100%"
          >
            <BackButton onClick={() => navigate(ROUTE_MAKE_RESERVATION)} />
            <Common.Div>
              <Pagination
                totalPages={pagination.total_pages}
                currentPageNumber={currentPageNumber}
                setCurrentPageNumber={setCurrentPageNumber}
              />
            </Common.Div>
          </Common.Div>
        </PaginationContainer>
      </LoaderWrapper>

      <ModalGallery
        isOpen={isGalleryOpen}
        setIsOpen={setIsGalleryOpen}
      />
    </Common.Div>
  )
}

export default ViewMakeReservationRoomsFound
